import React, { Component } from "react"
import TableAtaReuniao from "./TableAtaReuniao"
import Layout from "../../Layout"
import { Loading, HttpError } from "../../../components"
import * as ApiHelper from "../../../ApiHelper"
import Moment from "moment"
export default class AtaReuniao extends Component {
  constructor() {
    super()
    this.getAtaReuniaos = this.getAtaReuniaos.bind(this)
    this.didDelete = this.didDelete.bind(this)
    this.filter = this.filter.bind(this)
    this.state = { atas: [], initialAtas: [], showTable: false }
  }
  componentWillMount() {
    this.getAtaReuniaos()
  }
  getAtaReuniaos() {
    ApiHelper.getAtasDeReuniao((atas, error) => {
      if (atas) {
        this.setState({ atas: atas, initialAtas: atas, showTable: true })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialAtas.filter(ataReuniao => {
      return (
        Moment(ataReuniao.created_at)
          .format("D/MM/Y")
          .toLowerCase()
          .search(searchText) !== -1 ||
        ataReuniao.ata.toLowerCase().search(searchText) !== -1 ||
        ataReuniao.contrato.num_contrato.toLowerCase().search(searchText) !== -1
      )
    })
    this.setState({
      atas: filtered
    })
  }
  didDelete() {
    this.getAtaReuniaos()
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Fiscalização">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Fiscalização">
        {this.state.showTable ? (
          <TableAtaReuniao
            filter={this.filter}
            onDelete={this.didDelete}
            sizeClass=""
            title={"Atas de reunião"}
            subtitle={"Listagem das atas de reuniões criadas"}
            backgroundColor="as-blue"
            rows={this.state.atas}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/ata-reuniao/AtaReuniao.js